"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _contentComponent = _interopRequireDefault(require("../../content/content.component.js"));

var _messageContent = _interopRequireDefault(require("./message-content.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MessageContent = ({
  variant,
  title,
  transparent,
  children
}) => {
  return /*#__PURE__*/_react.default.createElement(_messageContent.default, {
    variant: variant,
    transparent: transparent
  }, /*#__PURE__*/_react.default.createElement(_contentComponent.default, {
    title: title,
    className: "message-content"
  }, children));
};

MessageContent.defaultProps = {
  variant: "info",
  transparent: false
};
MessageContent.propTypes = {
  variant: _propTypes.default.oneOf(["default", "error", "help", "info", "maintenance", "new", "success", "warning"]),
  title: _propTypes.default.node,
  transparent: _propTypes.default.bool,
  children: _propTypes.default.node
};
var _default = MessageContent;
exports.default = _default;